import { AccommodationScreen } from 'app/features/accommodation/screens'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page() {
  return <AccommodationScreen />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user

  return {
    props: {
      user: user || null,
    },
  }
})
